// Espelho de admin/src/components/Editor/Tiptap/safeUrl.js e
// admin/src/components/Editor/Tiptap/extensions/FileDownload/fileUrl.js
// (contrato do conteúdo Tiptap 1.0, seções 2.1 e 2.2).
// Os navegadores ignoram espaços e caracteres de controle no meio do esquema
// (`java\tscript:` executa), então eles saem antes do teste.
// eslint-disable-next-line no-control-regex
const IGNORED = /[\u0000- \u007f-\u009f\u00ad\u200b-\u200f\u2028\u2029\ufeff]/g
const SCHEME = /^([a-z][a-z0-9+.-]*):/i
export const DOWNLOAD_ROUTE = '/files/download/'

export const LINK_PROTOCOLS = [ 'http', 'https', 'mailto', 'tel' ]
export const IMAGE_PROTOCOLS = [ 'http', 'https' ]

export const cleanUrl = url => (typeof url === 'string' ? url.replaceAll(IGNORED, '') : '')

export const urlScheme = (url) => {
	const scheme = SCHEME.exec(cleanUrl(url))
	return scheme ? scheme[1].toLowerCase() : null
}

// Sem esquema é endereço relativo (inclusive `//host`, que herda http/https).
export const isSafeUrl = (url, protocols = LINK_PROTOCOLS) => {
	if (!cleanUrl(url)) return false
	const scheme = urlScheme(url)
	return !scheme || protocols.includes(scheme)
}

// Diferente do admin, o site não aceita `data:` em imagem.
export const safeImageSrc = src => (isSafeUrl(src, IMAGE_PROTOCOLS) ? src.trim() : null)

// `..` também percentual-codificado (`%2e%2e`, `.%2E`): a URL do download
// decodifica e o servidor enxergaria um segmento de volta de pasta
const DOT_SEGMENT = /(?:\.|%2e){2}/i

export const safeFilePath = (path) => {
	if (typeof path !== 'string') return null
	const clean = path.trim().replace(/^\/+/, '')
	// eslint-disable-next-line no-control-regex
	if (!clean || /^[a-z][a-z0-9+.-]*:/i.test(clean) || DOT_SEGMENT.test(clean) || /[\\<>"\u0000-\u001f]/.test(clean)) return null
	return clean
}

export const filePathFromUrl = (url) => {
	if (typeof url !== 'string') return null
	const index = url.indexOf(DOWNLOAD_ROUTE)
	return index === -1 ? null : safeFilePath(url.slice(index + DOWNLOAD_ROUTE.length))
}
